import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'

enum PageRoutes {
  ASUINPAIKKATODISTUS = CertificateTypes.ASUINPAIKKATODISTUS,
  ELOSSAOLOTODISTUS = CertificateTypes.ELOSSAOLOTODISTUS,
  AVIOLIITTOTODISTUS = CertificateTypes.AVIOLIITTOTODISTUS,
  SIVIILISAATYTODISTUS = CertificateTypes.SIVIILISAATYTODISTUS,
  SYNTYMATODISTUS = CertificateTypes.SYNTYMATODISTUS,
  UAETTODISTUS = CertificateTypes.UAETTODISTUS,
  AETTODISTUS_ORDERER = 'aet-hakemus1',
  AETTODISTUS_SIGNER = 'aet-hakemus2',
  INDEX = '/',
  LANDING = 'etusivu',
  INFO = 'lisatiedot',
  MY_CERTIFICATES = 'omat-todistukset',
}

export default PageRoutes
